import { createContext } from 'react';

export type MapsContextProps = {
  name: string;
  apiKey?: string;
  /** Forces the maps to display information in a particular language. Default - uses the user's preferred language setting as specified in the browser */
  language?: string;
  /** Alters the map's behavior based on a given country or territory (bias geocoding results towards the region). Default bias for application behavior towards the United States. */
  region?: string;
};

const MapsContext = createContext<MapsContextProps>({
  name: 'google',
  apiKey: ''
});

export default MapsContext;
